import { render, staticRenderFns } from "./gj.vue?vue&type=template&id=5274aeb4&scoped=true&"
import script from "./gj.vue?vue&type=script&lang=js&"
export * from "./gj.vue?vue&type=script&lang=js&"
import style0 from "./gj.vue?vue&type=style&index=0&id=5274aeb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5274aeb4",
  null
  
)

export default component.exports